<template>
  <b-card no-body class="menu-card overflow-hidden">
    <b-row no-gutters cols-xs="1" cols-sm="2">
      <b-col cols="12" sm="3">
        <b-card-body class="date-body">
          <b-card-text class="date-text">
            <span class="date-wrapper">
              <span class="date-string">{{ date }}</span>
              <span v-if="isNew(date)" class="new-badge">New!</span>
            </span>
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col cols="24" sm="21">
        <b-card-body class="information-body">
          <b-card-text class="information-text d-flex justify-content-left">
            {{ information }}
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "InformationSpaceItem",
  props: ["date", "information"],
  methods: {
    isNew(dateString) {
      const itemDate = new Date(dateString);
      const now = new Date();
      const daysDiff = (now - itemDate) / (1000 * 60 * 60 * 24);

      // 30日以内なら NEW を表示
      return daysDiff <= 30;
    }
  }
};
</script>

<style scoped>
.date-body {
  padding: 0 0 0 0;
}

.information-body {
  padding: 0 0 0 1.5rem;
}

.date-text {
  display: block;
}

.date-wrapper {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
}

.date-string {
  white-space: nowrap;
  display: inline-block;
  width: 85px;
}

.new-badge {
  display: inline-block;
  background-color: rgba(81, 5, 15, 0.15);
  color: rgba(81, 5, 15, 0.7);
  font-size: 0.75em;
  font-weight: bold;
  padding: 3px 8px;
  margin-left: 10px;
  border-radius: 4px;
  letter-spacing: 0.5px;
  border: 1px solid rgba(81, 5, 15, 0.12);
  white-space: nowrap;
  flex-shrink: 0;
}
</style>